import { useCallback } from "react";

import { useAvaCaseIQContext } from "../../Ava2/AvaCaseIQProvider";
import { useAvaContext } from "../../Ava2/AvaContext";
import { useAvaDialogContext } from "../../Ava2/AvaDialogContextProvider";
import { AvaResizableChat } from "../../Ava2/AvaResizableChat";

export const AVADialog = () => {
  const { handleCloseAvaDialog, changeFullscreenMode } = useAvaDialogContext();
  const { setConversationId } = useAvaContext();
  const { setIsCaseIQOpen } = useAvaCaseIQContext();

  const closeDialog = useCallback(() => {
    handleCloseAvaDialog();
    setConversationId();
    setIsCaseIQOpen(false);
    changeFullscreenMode(false);
  }, [handleCloseAvaDialog, setConversationId, setIsCaseIQOpen, changeFullscreenMode]);

  return <AvaResizableChat closeDialog={closeDialog} />;
};
